import type { RegularSymbolId, SymbolId } from './types';
import { ACTIVE_PAYOUTS } from './payout-tables';

export interface SymbolDefinition {
  readonly id: SymbolId;
  readonly name: string;
  readonly payouts: Readonly<Partial<Record<3 | 4 | 5, number>>>;
}

export const REGULAR_SYMBOL_IDS = Object.freeze([
  'BEWD',
  'DM',
  'JINZO',
  'TW',
  'ACE',
  'KING',
  'QUEEN',
  'JACK',
] as const satisfies readonly RegularSymbolId[]);

export const SYMBOLS: Readonly<Record<SymbolId, SymbolDefinition>> = Object.freeze({
  BEWD: Object.freeze({ id: 'BEWD', name: 'Weißer Drache', payouts: ACTIVE_PAYOUTS.BEWD }),
  DM: Object.freeze({ id: 'DM', name: 'Dunkles Magier-Mädchen', payouts: ACTIVE_PAYOUTS.DM }),
  JINZO: Object.freeze({ id: 'JINZO', name: 'Jinzo', payouts: ACTIVE_PAYOUTS.JINZO }),
  TW: Object.freeze({ id: 'TW', name: 'Zeitzauberer', payouts: ACTIVE_PAYOUTS.TW }),
  ACE: Object.freeze({ id: 'ACE', name: 'As', payouts: ACTIVE_PAYOUTS.ACE }),
  KING: Object.freeze({ id: 'KING', name: 'König', payouts: ACTIVE_PAYOUTS.KING }),
  QUEEN: Object.freeze({ id: 'QUEEN', name: 'Dame', payouts: ACTIVE_PAYOUTS.QUEEN }),
  JACK: Object.freeze({ id: 'JACK', name: 'Bube', payouts: ACTIVE_PAYOUTS.JACK }),
  WILD: Object.freeze({ id: 'WILD', name: 'Yugi-Wild', payouts: ACTIVE_PAYOUTS.WILD }),
  SCATTER: Object.freeze({ id: 'SCATTER', name: 'Puzzle-Scatter', payouts: Object.freeze({}) }),
  POG: Object.freeze({ id: 'POG', name: 'Topf der Gier', payouts: Object.freeze({}) }),
});

export function isRegularSymbolId(symbolId: SymbolId): symbolId is RegularSymbolId {
  return (REGULAR_SYMBOL_IDS as readonly SymbolId[]).includes(symbolId);
}
